import { Routes } from '@angular/router';
import { accountActiveGuard } from './core/auth/account-active.guard';
import { msalGuard } from './core/auth/msal.guard';
import { ShellComponent } from './layout/shell/shell';

export const routes: Routes = [
  {
    path: 'account-disabled',
    loadComponent: () =>
      import('./features/account-disabled/account-disabled').then((m) => m.AccountDisabledComponent),
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [msalGuard, accountActiveGuard],
    children: [
      { path: '', redirectTo: 'ript', pathMatch: 'full' },
      {
        path: 'ript',
        loadChildren: () => import('./features/ript/ript.routes').then((m) => m.riptRoutes),
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.routes').then((m) => m.usersRoutes),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
